import React, { useEffect, useRef, useState } from 'react';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import {
	Box,
	Typography,
	List,
	ListItem,
	ListItemText,
	ListItemButton,
	Paper,
	Checkbox,
} from '@mui/material';
import esLocale from '@fullcalendar/core/locales/es';
import { useSelector } from 'react-redux';
import { FAKE_DATA } from '../helpers/testData';
import { AREAS_PRIORITY } from '../components/utils/lists';

const data = FAKE_DATA;

const boxStyle = {
	display: 'flex',
	width: '68%',
	flexWrap: 'wrap',
	'& > :not(style)': {
		m: 2,
		p: 2,
		width: '100%',
		height: '250px',
	},
};

const paperStyle = {
	height: '94%',
};

const divStyle = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-evenly',
	height: '90%',
};

const divStyle2 = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-evenly',
};

export const TestHello = () => {
	return <h1>Hello world!!</h1>;
};
